// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const counter_RATINGS = ["%(counter)s hodnotenie", "%(counter)s hodnotenia", "%(counter)s hodnoten\u00ed"];
